import { createStore } from 'vuex'

import main from './modules/main'
import user from './modules/user'
import products from './modules/products'
import cart from './modules/cart'
import carteira from './modules/carteira'
import order from './modules/order'
import services from './modules/services'
import buscas from './modules/buscas'
import cupons from './modules/cupons'

const store = createStore({
  modules: {
    main,
    user,
    products,
    cart,
    carteira,
    order,
    services,
    buscas,
    cupons
  },
  strict: false,
})

export default store